import React from 'react';
import SidebarLayout from '../components/Layout/SidebarLayout';
import FileServer from '../components/Fileserver/FileServer';

const File = () => {
  return (
    <SidebarLayout>
    
      <FileServer />
    </SidebarLayout>
  );
};

export default File;